<div class="row pt-4">
    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 fw-bolder">
        {{pageInfo?.title}}
    </div>
    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <!--Breadcrumb-->
        <div class="bread align-items-center">
            <nav aria-label="breadcrumb bread">
                <ol class="breadcrumb bread">
                    <ng-template ngFor let-url [ngForOf]="pageInfo?.urls" let-last="last">
                        <li class="breadcrumb-item" *ngIf="!last" [routerLink]="url.url">
                            <a href='javascript:void(0)' *ngIf="url.title === 'Dashboard' ">Home Page</a>
                            <a href='javascript:void(0)' *ngIf="url.title != 'Dashboard' ">{{url.title}}</a>
                        </li>
                        <li class="breadcrumb-item active" *ngIf="last">{{url.title}}</li>
                    </ng-template>
                </ol>
            </nav>
        </div>
    </div>
</div>